export const MINORS_RELATIONSHIP_FIELD_NAMES = {
  legallyResponsible: 'legallyResponsible',
  isFosterChild: 'isFosterChild',
  jointCustody: 'jointCustody',
};
